import React from 'react';
import reactDOM from 'react-dom';
import App from './App.js';

reactDOM.render(<App/>, document.getElementById('root'));


